module.exports = __webpack_public_path__ + "static/img/default-avatar.0f09e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-avatar.png
// module id = PsX4
// module chunks = 1